import { render, staticRenderFns } from "./DispatchAccountManage.vue?vue&type=template&id=75dcf9ce&scoped=true&"
import script from "./DispatchAccountManage.vue?vue&type=script&lang=js&"
export * from "./DispatchAccountManage.vue?vue&type=script&lang=js&"
import style0 from "./DispatchAccountManage.vue?vue&type=style&index=0&id=75dcf9ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dcf9ce",
  null
  
)

export default component.exports